export default{
  setUser(state, payload) {
      state.token = payload.token;
      state.userId = payload.userId;
      state.didAutoLogout = false;
    },
  setItems(state,payload) {
    state.items = payload;
  },
  setItemView(state,payload) {
    state.itemview = payload;
  },
  setItemBuy(state, payload) {
    state.itemBuy = payload;
  },
  updateItemBuy(state, payload)
  {    
    let itembuy = state.itemBuy.data.find((itembuy)=>itembuy.id === payload.id);   
    itembuy.remain = payload.remain;
    itembuy.state = payload.state;
  },
  setItemValidity(state, payload) {
    state.itemValidity = payload;
  },
  setItemUse(state, payload) {
    state.itemUse = payload;
  },
  
};
